import React, { useEffect } from "react";
import { createBrowserHistory } from "history";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

import { logoutUser } from "../../actions/authActions";

import Home from "../pages/Home";
import Group from "../pages/Group";
import Project from "../pages/Project";
import Management from "../pages/Management";
import Models from "../pages/Models";
import Tasks from "../pages/Tasks";
import Label from "../pages/Annotate";
import ViewProjectAnnotation from "../pages/ViewProjectAnnotation";
import Test from "../pages/Test";

import OpenBenchmark from '../benchmark/OpenBenchmark';
import BenchmarkList from '../benchmark/BenchmarkList';
import Annotate from './../benchmark/Annotate';
import ViewAnnotation from '../benchmark/ViewAnnotation';
import QcList from '../benchmark/QcList';
import QcView from '../benchmark/QcView';
import ViewResponses from '../benchmark/ViewResponses';

import Classification from '../pages/Classification';
import ClassificationProject from '../pages/ClassificationProject';
import ClassificationTest from '../pages/ClassificationTest';

const history = createBrowserHistory();

function Dashboard(props) {
  useEffect(() => {
    if (!props.auth.isAuthenticated) {
      props.history.push("/login");
    }
  }, [props]);

  const onLogoutClick = (e) => {
    e.preventDefault();
    history.replace("/");
    props.logoutUser();
  };

  return (
    <div style={{ minHeight: '100vh' }}>
      <Switch>
        <Route exact path={`/`} render={(routerProps) => <Home {...routerProps} onLogout={onLogoutClick} />} />
        <Route exact path={`/group/:groupId`} component={Group} />
        <Route exact path={`/management`} component={Management} />
        <Route exact path={`/models`} component={Models} />
        <Route exact path={`/tasks`} component={Tasks} />
        <Route exact path={`/classification/:groupId`} component={Classification} />
        <Route exact path={`/classification/project/:groupId/:projectId`} component={ClassificationProject} />
        <Route exact path={`/classification/test/:groupId`} component={ClassificationTest} />

        <Route exact path={`/project/:projectId`} component={Project} />
        <Route exact path={`/annotate/:projectId/:taskId`} component={Label} />
        <Route exact path={`/viewAnnotation/:projectId/:imageId`} component={ViewProjectAnnotation} />
        <Route exact path={`/test/:projectId`} component={Test} />
        <Route exact path={`/project/benchmarks/:projectId`} component={BenchmarkList} />
        <Route exact path={`/group/benchmarks/:groupId`} component={BenchmarkList} />
        <Route exact path={`/benchmark/:benchmarkId`} component={OpenBenchmark} />
        <Route exact path={`/benchmark/annotate/:benchmarkId/:imageKey`} component={Annotate} />
        <Route exact path={`/benchmark/viewAnnotation/:benchmarkId/:imageKey`} component={ViewAnnotation} />
        <Route exact path={`/benchmark/viewResponse/:benchmarkId/:imageKey`} component={ViewResponses} />
        <Route exact path={`/benchmark/qc/list/:benchmarkId`} component={QcList} />
        <Route exact path={`/benchmark/qc/view/:benchmarkId/:taskId`} component={QcView} />
      </Switch>
    </div>
  );
}

Dashboard.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(Dashboard);
